import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { ActionTypes } from 'modules/iterableGoals/ducks/actionTypes';
import {
  CampaignContributionsAction,
  CampaignContributionsInfoData,
  CampaignContributionsResultsData,
  CampaignContributionsState,
  CampaignContributionTableSort,
} from 'modules/iterableGoals/types';

export const initialCampaignContributionsState: CampaignContributionsState = {
  data: {
    info: <CampaignContributionsInfoData>{},
    results: <CampaignContributionsResultsData[]>[],
    totalSends: 0,
  },
  input: {
    sort: {
      sortBy: CampaignContributionTableSort.STATUS,
      sortDirection: SORT_DIRECTIONS.DESCENDING,
    },
    pagination: {
      offset: 0,
      limit: 10,
      page: 1,
    },
  },
  loading: true,
  error: false,
};

export const campaignContributionsReducer = (
  state = initialCampaignContributionsState,
  action?: CampaignContributionsAction,
) => {
  switch (action?.type) {
    case ActionTypes.FETCH_CAMPAIGN_CONTRIBUTIONS_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };

    case ActionTypes.FETCH_CAMPAIGN_CONTRIBUTIONS_RESPONSE:
      return {
        ...state,
        data: action?.payload,
        error: false,
        loading: false,
      };

    case ActionTypes.FETCH_CAMPAIGN_CONTRIBUTIONS_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
      };

    case ActionTypes.SET_CAMPAIGN_CONTRIBUTION_PAGINATION:
      return {
        ...state,
        input: {
          ...state.input,
          pagination: action?.payload,
        },
      };

    case ActionTypes.SET_CAMPAIGN_CONTRIBUTION_SORT:
      return {
        ...state,
        input: {
          ...state.input,
          sort: action?.payload,
        },
      };

    default:
      return state;
  }
};
